
<template>
  <div>
    <v-container>
      <div
        class="d-flex justify-space-between align-start"
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'flex-column'"
      >
        <div
          :style="
            $vuetify.breakpoint.mdAndUp
              ? 'min-width: 400px; max-width: 800px'
              : 'width:100%'
          "
        >
          <v-text-field
            dense
            label="Traži"
            v-model="search"
            outlined
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
          <v-spacer></v-spacer>
        </div>
      </div>

      <v-data-table
        :loading="$wait.is('studenti')"
        :headers="headers"
        :items="getStudenti.data"
        :items-per-page="getStudenti.per_page"
        hide-default-footer
        no-data-text="Nema podataka"
        no-results-text="Nema podataka"
        class="elevation-1 curs"
        style="width: 99%"
      >
        <template v-slot:[`item.ime`]="{ item }">
          <span>{{ titleCase(item.ime) }}</span>
        </template>
        <template v-slot:[`item.prezime`]="{ item }">
          <span>{{ titleCase(item.prezime) }}</span>
        </template>
        <template v-slot:[`item.e_mail`]="{ item }">
          <span v-if="item.e_mail">{{ item.e_mail }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2"
                @click="goToDetails(item)"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                mdi-information
              </v-icon>
            </template>

            <span> Detaljan pregled</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-dialog  v-model="openDetails" fullscreen>
        <v-toolbar color="rgb(8, 71, 118)" v-if="selectedStudent">
          <v-icon @click="closeDetails" class="mr-2 ml-0" color="white" left
            >mdi-close</v-icon
          >
          <h4 style="color: white">
            {{ selectedStudent.ime }} {{ selectedStudent.prezime }}
          </h4>
        </v-toolbar>
        <detalji-student :selectedStudent="selectedStudent"></detalji-student>
      </v-dialog>
      <div class="text-center pt-2">
        <v-pagination
          v-model="page"
          @input="goTo"
          total-visible="20"
          :length="getStudenti.last_page"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { waitFor } from "vue-wait";
export default {
  name: "Studenti",
  // metaInfo: {
  //   title: "Studenti  - Registar radova",
  // },
  data: () => ({
    selectedStudent: null,
    openDetails: false,
    searchStudents: "",
    headers: [
      {
        text: "Ime",
        align: "start",
        value: "ime",
        sortable: false,
      },
      {
        text: "Prezime",
        align: "start",
        value: "prezime",
        sortable: false,
      },
      { text: "AAI korisničko ime", value: "aai_kor_ime", sortable: false },
      { text: "E-mail (osobni)", value: "e_mail", sortable: false },

      { text: "", value: "actions", sortable: false, align: "end" },
    ],
    page: 1,
  }),

  computed: {
    ...mapGetters(["getStudenti"]),
    search: {
      set(value) {
        waitFor("studenti", async function () {
          this.searchStudents = value;
          await this.$store.dispatch("getStudenti", { item: 1, search: value });
        }).apply(this);
      },
      get() {
        return this.searchStudents;
      },
    },
  },
  methods: {
    goToDetails(student) {
      this.selectedStudent = student;
      waitFor("getStudentDetails", async function () {
        await this.$store.dispatch("fetchOsoba", student.id);
      }).apply(this);

      this.openDetails = true;
    },
    async closeDetails() {
      this.openDetails = false;
    },
    goTo(item) {
      waitFor("studenti", async function () {
        this.page = item;
        await this.$store.dispatch("getStudenti", {
          item: item,
          search: this.searchStudents,
        });
      }).apply(this);
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },
  },
  beforeMount() {
    waitFor("studenti", async function () {
      await this.$store.dispatch("getStudenti", { item: 1, search: "" });
    }).apply(this);
  },
};
</script>
